export const SYSTEM_LOADING_MUTATION_TOGGLE_LOADING = 'system_loading_mutation_toggle_loading'

export const SYSTEM_LOADING_GETTER_IS_LOADING = 'system_loading_getter_is_loading'
